import {
  Button as reactButton,
  Card as reactCard,
  CardGroup as reactCardGroup,
  CloseButton as reactCloseButton,
  FormGroup,
} from "reactstrap";
import styled from "styled-components";
import { Input } from "../common/style";

const Card = styled(reactCard)`
  height: ${(props) => props.height};
  padding: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background: #FFFFFF !important;
  overflow: hidden;

  &:hover {
    outline: 2px solid #2c92e6;
  }

  &.selected {
    outline: 2px solid #2c92e6;
  }

  &.disabled {
    background: #DDD !important;
    outline: none;
    cursor: not-allowed;
  }

  &.no-effect {
    &:hover {
      outline: none;
    }
  }
`;
const Pill = styled.button`
  background-color: ${(props) =>
    props.active === "true" ? "#007bff" : "#f0f2f5"};
  color: ${(props) => (props.active === "true" ? "#fff" : "black")};
  font-size: 15px;
  border: 1px solid transparent;
  border-radius: 5px;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #007bff;
    color: #fff;
  }
`;
const CardGroup = styled(reactCardGroup)`
  row-gap: ${(props) => (props.browser === "true" ? "20px" : "0px")};
`;

const CardImgContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: ${(props) => (props.minHeight ? props.minHeight : "100px")};
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : "100px")};
`;

const CardProductCode = styled.p`
  margin: 0;
  color: #666666;
  text-align: center;
  font-weight: 600;
`;

const CardProductName = styled.p`
  margin: 0;
  color: #999999;
  font-size: 10px !important;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
`;

const CardProductCheck = styled.div.attrs({
  className: "position-absolute z-3 rounded-circle bg-white pointer",
})`
  top: -7px;
  left: 2px;
  color: #2c92e6;
  font-size: 13px !important;
  padding-inline: 3px;
  border: 1px solid #2c92e6;
  box-shadow: 0px 4px 4px 0px #00000040;
`;

const CardProductUnCheck = styled.div.attrs({
  className:
    "d-flex justify-content-center align-items-center position-absolute z-3 rounded-circle bg-white pointer",
})`
  top: -8px;
  left: -8px;
  height: 16px;
  width: 16px;
  color: #999999;
  border: 1px solid #999999;
`;

const CloseButton = styled(reactCloseButton)`
  opacity: 0.3;
  font-size: ${(props) => props.size + "! important"};
  border-radius: 33px;
  padding: ${(props) => props.padding};
  margin: 0 !important;
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  height: fit-content;
  width: fit-content;
  background: #ffff;
  box-shadow: 0 0 10px #ccc;
  border-radius: 450px;
  padding: 3px;
  z-index: 10;
`;

const Option = styled(reactButton)`
  background-color: #f0f2f5;
  font-size: 15px;
  color: black;
  border: 0;
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
  &:disabled {
    background: #dddddd;
    color: #aaaaaa;
  }
`;

const OptionsContainer = styled.div`
  gap: 12px;
`;

const OptionImage = styled.img`
  height: ${(props) => props.height || 16}px;
  width: ${(props) => props.width || 16}px;
  margin-top: -4px;
`;

const ProductContainer = styled.div`
  width: 100%;
  transition: width 0.5s ease;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
`;

const ProductInfoContainer = styled.div`
  width: ${(props) => (props.browser === "false" ? "100%" : "35%")};
`;

const ProductImgContainer = styled.div`
  position: relative;
`;

const PropertiesContainer = styled.div`
  height: ${(props) =>
    props.browser == "true" ? props.height : "100% !important"};
  overflow: scroll;
  transition: width 0.8s ease;
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  margin-top: 1rem;
`;

const SearchContainer = styled.div`
  position: absolute;
  background: white;
  width: 100%;
`;

const SearchInput = styled(Input)`
  border-radius: 5px;
  border: 1px solid #ddd;
  position: relative;
  bottom: 0;

  &:focus {
    outline: 2px solid #2c92e6;
    box-shadow: none;
  }
`;

const Thumbnail = styled.div`
  height: ${(props) => (props.browser == "true" ? "100px" : "75px")};
  width: ${(props) => (props.browser == "true" ? "150px" : "75px")};
  border: 1px solid #ddd;
`;

const ThumbnailContainer = styled.div`
  gap: 20px;
  @media (max-width: 578px) {
    display: ${(props) =>
      props.mobileview === "false" ? "none !important" : "flex"};
  }
`;

const CatalogsContainer = styled.div.attrs({
  className: "d-flex flex-column row-gap-3",
})`
  height: 75vh;
  overflow: scroll;
  margin-top: 15px;
  transition: width 0.8s ease;
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  padding: 5px;
  &.blurred {
    filter: blur(1px);
    -webkit-filter: blur(1px);
  }
  .row {
    --bs-gutter-x: 10px !important;
    --bs-gutter-y: 10px !important;
  }
`;

const ProductPersonalizeContainer = styled.div`
  display: flex;
  padding: 1.5rem;
  column-gap: 1.5rem;
  @media (max-width: 900px) {
    flex-direction: column;
  }
  @media (max-width: 578px) {
    padding: 1rem 1rem 0 1rem;
  }
`;

const ProductPersonalizeInfoContainer = styled.div`
  width: 30%;
  @media (max-width: 1450px) {
    width: 40%;
  }
  @media (max-width: 1050px) {
    width: 50%;
  }
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const ProductCustomizableContainer = styled.div`
  width: 70%;
  @media (max-width: 1450px) {
    width: 60%;
  }
  @media (max-width: 1050px) {
    width: 50%;
  }
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InternalsDimensionIcon = styled.div`
  position: absolute;
  height: ${(props) => props.dimension === "width" && "1px"};
  width: ${(props) => props.dimension === "height" && "1px"};
  background-color: ${(props) =>
    props.active ? "rgba(44, 146, 230)" : "black"};

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-style: solid;
    transform: ${(props) =>
      props.dimension === "width" ? "translateY(-50%)" : "translateX(-50%)"};
  }

  &::before {
    ${(props) =>
      props.dimension === "width"
        ? `
            border-width: 5px 5px 4px 0;
            border-color: transparent ${
              props.active ? "rgba(44, 146, 230)" : "black"
            } transparent transparent;
          `
        : `
            bottom: 0px;
            border-width: 5px 4px 0 5px;
            border-color: ${
              props.active ? "rgba(44, 146, 230)" : "black"
            } transparent transparent transparent;
          `}
  }

  &::after {
    ${(props) =>
      props.dimension === "width"
        ? `
            right: 0px;
            border-width: 4px 0 5px 5px;
            border-color: transparent transparent transparent ${
              props.active ? "rgba(44, 146, 230)" : "black"
            };
          `
        : `
            border-width: 0 4px 5px 5px;
            border-color: transparent transparent ${
              props.active ? "rgba(44, 146, 230)" : "black"
            } transparent;
          `}
  }
`;

const SpaceInfoButton = styled(reactButton)`
  border: ${(props) => `1px solid ${props.color}`};
  color: ${(props) => props.color};
  &:hover {
    background-color: ${(props) => `${props.color}`};
    color: white;
  }
`;
const SpaceButton = styled(reactButton)`
  border: ${(props) => `1px solid ${props.color}`};
  color: ${(props) => props.color};
  &:hover {
    color: ${(props) => `${props.color}`};
    border: ${(props) => `1px solid ${props.color}`};
  }
`;

const SpaceInfoButton2 = styled(reactButton)`
  border: ${(props) => `1px solid ${props.color}`};
  background-color: ${(props) => `${props.color}`};
  color: white;
  &:hover {
    background-color: ${(props) => `${props.color}`};
    color: white;
  }
`;

const ToggleContainer = styled(FormGroup).attrs({
  className: "toggle-switch p-0 pointer d-flex align-items-center",
})`
  border-width: 0px 0px 1px 1px;
  border-color: #00000026;
  border-style: solid;
  border-radius: 0 0 0 10px;
`;

const ToggleOptionContainer = styled.div.attrs({
  className: "toggle-buttons d-flex",
})`
  border-radius: 25px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border: 1px solid #ccc;
`;

const ToggleOption = styled.div.attrs({
  className: "toggle-option fw-bold text-center pointer",
})`
  padding: 8px 20px;
  transition: color 0.3s ease;
  color: #666;
  border-radius: 25px;

  &:hover {
    color: var(--bs-primary);
  }

  &.active {
    background-color: var(--bs-primary);
    color: white;
  }
`;

const AddedProductsContainer = styled.div.attrs({
  className: "position-fixed bottom-0 bg-white ms-1",
})`
  box-shadow: 0px -4px 4px 0px #aaaaaa;
  width: 490px;
`;

export {
  Card,
  Pill,
  CardGroup,
  CardImgContainer,
  CardProductCode,
  CardProductName,
  CardProductCheck,
  CardProductUnCheck,
  CloseButton,
  CloseButtonContainer,
  Option,
  OptionsContainer,
  OptionImage,
  ProductContainer,
  ProductInfoContainer,
  ProductImgContainer,
  PropertiesContainer,
  SearchContainer,
  SearchInput,
  Thumbnail,
  ThumbnailContainer,
  CatalogsContainer,
  ProductPersonalizeContainer,
  ProductPersonalizeInfoContainer,
  ProductCustomizableContainer,
  InternalsDimensionIcon,
  SpaceInfoButton,
  SpaceButton,
  SpaceInfoButton2,
  ToggleContainer,
  ToggleOptionContainer,
  ToggleOption,
  AddedProductsContainer,
};
